

























































import { Component, Mixins } from 'vue-property-decorator'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AuthMixin from '@/mixins/AuthMixin'
import { sharedInstance as authService } from '@/services/AuthService'
import { sharedInstance as analytics } from '@/services/AnalyticsService'

import '@/services/ProjectsService'
import '@/services/TemplatesService'
import '@/services/UserMetaDataService'

/* eslint-disable */
// Start Survicate code
(function (w) {
	var s = document.createElement('script');
	s.src = '//survey.survicate.com/workspaces/0cb8beaae3d682c0d37c1fde8eee8bc3/web_surveys.js';
	s.async = true;
	var e = document.getElementsByTagName('script')[0];
	// @ts-ignore
	e.parentNode.insertBefore(s, e);
})(window);
// End of Survicate code

if (process.env.NODE_ENV === 'production')
{
	// Start FullStory
	window['_fs_debug'] = false;
	window['_fs_host'] = 'fullstory.com';
	window['_fs_script'] = 'fullstory.com/s/fs.js';
	window['_fs_org'] = 'N30V9';
	window['_fs_namespace'] = 'FS';
	
	(function(m,n,e,t,l,o,g,y){
		// @ts-ignore
		if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');} return;}
		// @ts-ignore
		g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];
		// @ts-ignore
		o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_script;
		// @ts-ignore
		y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);
		// @ts-ignore
		g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};
		// @ts-ignore
		g.shutdown=function(){g("rec",!1)};g.restart=function(){g("rec",!0)};
		// @ts-ignore
		g.log = function(a,b) { g("log", [a,b]) };
		// @ts-ignore
		g.consent=function(a){g("consent",!arguments.length||a)};
		// @ts-ignore
		g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};
		// @ts-ignore
		g.clearUserCookie=function(){};
	})(window,document,window['_fs_namespace'],'script','user');
	// End FullStory
}
/* eslint-enable */

@Component({
	components: {
		LoadingComponent
	}
})
export default class App extends Mixins(AuthMixin)
{
	get pageTitle()
	{
		if (!this.isSignedIn)
		{
			return 'Welcome!'
		}

		switch (this.$route.name)
		{
			case 'dashboard':
				return 'Dashboard'

			case 'new-project':
			{
				switch (this.$route.query.type)
				{
					default:
						return 'Create New Project'

					case 'package':
						return 'Create New Package'

					case 'template':
						return 'Create New Template'
				}
			}

			default:
				return ''
		}
	}

	created()
	{
		if (this.$route.query.pro)
		{
			this.$store.commit('auth/setProRequest', true)
		}
	}

	mounted()
	{
		analytics.logPageView()
	}

	private handleLogout()
	{
		authService.signOut()
	}
}
